module.exports = __webpack_public_path__ + "static/media/frankkienl-310.ece4b2b7.png";